module.exports = __webpack_public_path__ + "static/logo-full-c23a0df9f2bcd5e5ea5a1441f407cebb.svg";